<ng-container *ngIf="IsDesktop; then desktopMode; else handHeldMode"></ng-container>

<ng-template #desktopMode>
    <app-top-navigation-toolbar >
        <router-outlet></router-outlet>
        <app-footer></app-footer>
    </app-top-navigation-toolbar>
</ng-template>
<ng-template #handHeldMode>
    <app-side-nav-inner-toolbar>
        <router-outlet></router-outlet>
        <ng-container [ngTemplateOutlet]="footer"></ng-container>
    </app-side-nav-inner-toolbar>
</ng-template>

<ng-template #footer>
    <app-footer></app-footer>
</ng-template>

<dx-toast [visible]="IsAlmostTimedOut" [type]="'info'" [message]="this.idleState" [displayTime]="90000">
</dx-toast>
